import { render, staticRenderFns } from "./LectureContent.vue?vue&type=template&id=71538052"
import script from "./LectureContent.vue?vue&type=script&lang=js"
export * from "./LectureContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports